import { ResponseBase } from '../response-base.model';
import { TipoEncuesta } from '../tipo-encuesta.model';
import { EvaluacionesInterna } from './evaluaciones-internas-.model';


export class ListadoEvaluacionInterna extends ResponseBase {
    evaluacionInt: EvaluacionesInterna[] = [];
    tipoEvaluacion : TipoEncuesta[] =[]
}
